(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const vorlage = document.querySelector('[data-nach-oben-vorlage]');
    if (!vorlage) return;

    const knopf = vorlage.content.firstElementChild.cloneNode(true);
    document.body.append(knopf);

    // Ein Beobachter am Seitenanfang statt eines scroll-Handlers: Der
    // Browser meldet nur den Wechsel, statt bei jedem Bildpunkt Arbeit auf
    // dem Hauptthread zu erzeugen.
    const marke = document.createElement('div');
    marke.style.cssText = 'position:absolute;top:100vh;height:1px;width:1px';
    document.body.prepend(marke);

    new IntersectionObserver(([eintrag]) => {
      knopf.toggleAttribute(
        'data-sichtbar',
        !eintrag.isIntersecting && eintrag.boundingClientRect.top < 0,
      );
    }).observe(marke);

    knopf.addEventListener('click', () => {
      const sanft = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';
      window.scrollTo({ top: 0, behavior: sanft });
      // Fokus zurueck an den Anfang, sonst bliebe er am Knopf haengen und
      // die Tabulatortaste setzte die Reise am Seitenende fort.
      document.querySelector('.skip-to-content')?.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["consent-banner"] && !Shopify.designMode) return;
  try {
    // Einwilligung ueber Shopifys Customer Privacy API. Ohne JavaScript
  // erscheint kein Banner - dann laesst sich aber auch keine Einwilligung
  // erteilen, und Shopify laedt bei aktiver Beschraenkung nichts
  // Einwilligungspflichtiges.
  (() => {
    const banner = document.querySelector('[data-einwilligung]');
    if (!banner) return;

    const auswahl = banner.querySelector('[data-einwilligung-auswahl]');
    const knopfEinstellen = banner.querySelector('[data-einwilligung-einstellen]');
    const knopfSpeichern = banner.querySelector('[data-einwilligung-speichern]');
    const felder = () => Array.from(banner.querySelectorAll('[data-einwilligung-feld]'));

    const setzen = (werte) => {
      window.Shopify?.customerPrivacy?.setTrackingConsent(werte, () => {
        banner.hidden = true;
      });
    };

    banner.querySelector('[data-einwilligung-annehmen]').addEventListener('click', () => {
      setzen({ analytics: true, marketing: true, preferences: true, sale_of_data: false });
    });

    banner.querySelector('[data-einwilligung-ablehnen]').addEventListener('click', () => {
      setzen({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
    });

    knopfEinstellen.addEventListener('click', () => {
      auswahl.hidden = false;
      knopfEinstellen.hidden = true;
      knopfSpeichern.hidden = false;
      auswahl.querySelector('input:not([disabled])')?.focus();
    });

    knopfSpeichern.addEventListener('click', () => {
      const werte = { sale_of_data: false };
      felder().forEach((feld) => {
        werte[feld.dataset.einwilligungFeld] = feld.checked;
      });
      setzen(werte);
    });

    // Ueber diesen Verweis laesst sich die Wahl spaeter aendern - Pflicht,
    // und er steht im Fussbereich.
    document.addEventListener('click', (ereignis) => {
      if (!ereignis.target.closest('[data-einwilligung-oeffnen]')) return;
      ereignis.preventDefault();
      banner.hidden = false;
      const stand = window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || {};
      felder().forEach((feld) => {
        feld.checked = stand[feld.dataset.einwilligungFeld] === 'yes';
      });
      auswahl.hidden = false;
      knopfEinstellen.hidden = true;
      knopfSpeichern.hidden = false;
    });

    // Erst zeigen, wenn Shopify fuer diesen Besucher eine Beschraenkung kennt
    // und noch keine Wahl vorliegt. Die API meldet sich, sobald sie bereit ist.
    const pruefen = () => {
      const cp = window.Shopify?.customerPrivacy;
      if (!cp?.shouldShowBanner) return;
      if (cp.shouldShowBanner()) banner.hidden = false;
    };

    document.addEventListener('visitorConsentCollected', () => {
      banner.hidden = true;
    });

    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (fehler) => {
        if (fehler) {
          console.warn('[Einwilligung] API nicht ladbar:', fehler);
          return;
        }
        pruefen();
      });
    } else {
      pruefen();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    // Vorschaubilder: nur die Buehne bewegen, nicht die Seite.
  //
  // Die Daumen sind Sprungmarken auf das jeweilige Bild - so funktionieren sie
  // auch ohne JavaScript. Der Ankersprung des Browsers holt das Ziel aber ins
  // Blickfeld, indem er die *ganze Seite* scrollt; bei einer Buehne, die schon
  // sichtbar ist, ruckt die Seite dabei sichtbar nach unten. Mit JavaScript
  // wird stattdessen nur waagerecht im Container gescrollt.
  //
  // Bewusst unabhaengig von der Grossansicht: Die laesst sich abschalten, das
  // Blaettern muss trotzdem ruhig bleiben.
  (() => {
    const buehne = document.querySelector('.produkt-medien__buehne');
    const vorschau = document.querySelector('.produkt-medien__vorschau');
    if (!buehne || !vorschau) return;

    vorschau.addEventListener('click', (ereignis) => {
      const verweis = ereignis.target.closest('a[href^="#media-"]');
      if (!verweis) return;

      const ziel = document.getElementById(verweis.getAttribute('href').slice(1));
      if (!ziel) return;

      ereignis.preventDefault();
      // Ohne behavior-Angabe gilt scroll-behavior aus dem Stylesheet - und
      // damit auch dessen Ruecknahme bei "Bewegung reduzieren".
      buehne.scrollTo({ left: ziel.offsetLeft - buehne.offsetLeft });
    });
  })();

  // Grossansicht der Produktbilder. Reine Zugabe: Ohne JavaScript bleibt die
  // Galerie eine gewoehnliche Bilderreihe.
  (() => {
    const vorlage = document.querySelector('[data-zoom-vorlage]');
    const buehne = document.querySelector('.produkt-medien__buehne');
    if (!vorlage || !buehne) return;

    const dialog = vorlage.content.firstElementChild.cloneNode(true);
    document.body.append(dialog);

    const grossbild = dialog.querySelector('[data-bildzoom-bild]');

    buehne.addEventListener('click', (ereignis) => {
      // Zwei Wege fuehren hierher: der Mausklick auf das Bild und Enter oder
      // Leertaste auf dem Knopf, der es traegt. Im zweiten Fall ist das Ziel
      // der Knopf - closest sucht nach oben und faende von dort aus nie ein
      // Bild. Deshalb erst den Knopf suchen und das Bild darin holen.
      const knopf = ereignis.target.closest('.produkt-medien__lupe');
      const bild = knopf
        ? knopf.querySelector('img.produkt-medien__bild')
        : ereignis.target.closest('img.produkt-medien__bild');
      if (!bild) return;

      // Dieselbe Datei in hoeherer Aufloesung anfordern. Bleibt die Adresse
      // unveraendert - etwa bei einem Platzhalter -, wird eben die bekannte
      // Fassung gezeigt.
      grossbild.src = bild.currentSrc.replace(/([?&]width=)\d+/, '$12400');
      grossbild.alt = bild.alt;
      // Echte Masse uebernehmen, sobald sie bekannt sind - sonst behielte das
      // Bild das quadratische Platzhalterverhaeltnis.
      if (bild.naturalWidth && bild.naturalHeight) {
        grossbild.width = bild.naturalWidth;
        grossbild.height = bild.naturalHeight;
      }
      dialog.showModal();
    });

    dialog.addEventListener('click', (ereignis) => {
      // Klick auf die Flaeche neben dem Bild schliesst - das erwarten die
      // meisten, und der Schliessknopf bleibt fuer alle anderen.
      if (ereignis.target === dialog || ereignis.target.closest('[data-bildzoom-schliessen]')) {
        dialog.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-form"] && !Shopify.designMode) return;
  try {
    // Suchvorschlaege ueber die Predictive Search API. Reine Ergaenzung: Ohne
  // JavaScript bleibt das Formular ein gewoehnliches GET-Suchformular.
  //
  // querySelectorAll statt querySelector: Es gibt zwei Formulare im Dokument -
  // eines im Kopfbereich, eines auf der Suchseite. Jedes bekommt seine eigene
  // Steuerung, sonst bliebe das zweite tot.
  document.querySelectorAll('[data-vorschlaege-url]').forEach((formular) => {
    const feld = formular.querySelector('[data-vorschlaege-feld]');
    const ziel = formular.querySelector('[data-vorschlaege-ziel]');
    const liveBereich = formular.querySelector('[data-vorschlaege-live]');
    if (!feld || !ziel) return;

    const endpunkt = formular.dataset.vorschlaegeUrl;
    const MINDESTLAENGE = 2;
    const WARTEZEIT_MS = 250;

    feld.setAttribute('role', 'combobox');
    feld.setAttribute('aria-controls', ziel.id);
    feld.setAttribute('aria-autocomplete', 'list');
    feld.setAttribute('aria-expanded', 'false');

    let zeitgeber = null;
    let laufenderAbruf = null;
    let markiert = -1;

    const eintraege = () => Array.from(ziel.querySelectorAll('[role="option"]'));

    const schliessen = () => {
      ziel.hidden = true;
      ziel.replaceChildren();
      feld.setAttribute('aria-expanded', 'false');
      feld.removeAttribute('aria-activedescendant');
      markiert = -1;
    };

    const markieren = (index) => {
      const liste = eintraege();
      if (liste.length === 0) return;

      liste.forEach((eintrag) => eintrag.setAttribute('aria-selected', 'false'));
      markiert = (index + liste.length) % liste.length;

      const aktiv = liste[markiert];
      aktiv.setAttribute('aria-selected', 'true');
      feld.setAttribute('aria-activedescendant', aktiv.id);
      aktiv.scrollIntoView({ block: 'nearest' });
    };

    const laden = async (begriff) => {
      if (laufenderAbruf) laufenderAbruf.abort();
      laufenderAbruf = new AbortController();

      const arten = formular.dataset.vorschlaegeArten || 'product,page,article';
      const anzahl = formular.dataset.vorschlaegeAnzahl || '5';

      const adresse =
        endpunkt +
        '?q=' +
        encodeURIComponent(begriff) +
        '&section_id=predictive-search' +
        '&resources[type]=' +
        encodeURIComponent(arten) +
        '&resources[limit]=' +
        encodeURIComponent(anzahl);

      try {
        const antwort = await fetch(adresse, { signal: laufenderAbruf.signal });
        if (!antwort.ok) {
          console.warn('[Suche] Vorschlaege nicht abrufbar:', antwort.status);
          schliessen();
          return;
        }

        const abschnitt = new DOMParser()
          .parseFromString(await antwort.text(), 'text/html')
          .querySelector('#shopify-section-predictive-search');

        if (!abschnitt) {
          console.warn('[Suche] Abschnitt predictive-search fehlt in der Antwort');
          schliessen();
          return;
        }

        // Knotenweise statt ueber innerHTML: Die Knoten sind bereits geparst,
        // replaceChildren adoptiert sie direkt aus dem Antwortdokument.
        ziel.replaceChildren(...abschnitt.childNodes);
        ziel.hidden = false;
        feld.setAttribute('aria-expanded', 'true');
        markiert = -1;

        const meldung = ziel.querySelector('[data-vorschlaege-meldung]');
        if (liveBereich && meldung) liveBereich.textContent = meldung.textContent.trim();
      } catch (fehler) {
        if (fehler.name === 'AbortError') return;
        console.warn('[Suche] Vorschlaege fehlgeschlagen:', fehler);
        schliessen();
      }
    };

    feld.addEventListener('input', () => {
      const begriff = feld.value.trim();
      window.clearTimeout(zeitgeber);

      if (begriff.length < MINDESTLAENGE) {
        schliessen();
        return;
      }

      zeitgeber = window.setTimeout(() => laden(begriff), WARTEZEIT_MS);
    });

    feld.addEventListener('keydown', (ereignis) => {
      if (ereignis.key === 'Escape') {
        schliessen();
        return;
      }

      if (ziel.hidden) return;

      if (ereignis.key === 'ArrowDown') {
        ereignis.preventDefault();
        markieren(markiert + 1);
      } else if (ereignis.key === 'ArrowUp') {
        ereignis.preventDefault();
        markieren(markiert - 1);
      } else if (ereignis.key === 'Enter' && markiert >= 0) {
        // Nur abfangen, wenn wirklich ein Vorschlag markiert ist - sonst muss
        // Enter das Formular ganz normal absenden.
        const verweis = eintraege()[markiert].querySelector('a');
        if (verweis) {
          ereignis.preventDefault();
          window.location.assign(verweis.href);
        }
      }
    });

    document.addEventListener('click', (ereignis) => {
      if (!formular.contains(ereignis.target)) schliessen();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shop-nav-links"] && !Shopify.designMode) return;
  try {
    // Schliesst offene Untermenues bei Escape und bei einem Klick daneben.
  // Reine Ergaenzung - ohne JavaScript bleiben sie offen, bis erneut auf den
  // Titel geklickt wird.
  (() => {
    const gruppen = () => Array.from(document.querySelectorAll('.shop-nav__gruppe[open]'));

    document.addEventListener('click', (ereignis) => {
      gruppen().forEach((gruppe) => {
        if (!gruppe.contains(ereignis.target)) gruppe.open = false;
      });
    });

    document.addEventListener('keydown', (ereignis) => {
      if (ereignis.key !== 'Escape') return;

      gruppen().forEach((gruppe) => {
        gruppe.open = false;
        // Fokus zurueck auf den Titel, sonst landet er im Nichts.
        const knopf = gruppe.querySelector('summary');
        if (knopf && gruppe.contains(document.activeElement)) knopf.focus();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
